<template>
	<div class="index-content">
		<div class='index-banner'>
			<el-carousel>
				<el-carousel-item v-for="(item,index) in carouselList" :key="index" >
					<img :src="item.image" alt="" class="banner-img" @click="handleCarouselJump(item)">
				</el-carousel-item>
			</el-carousel>
		</div>
		<div class="space"></div>
		<div v-if="menus.length !==0">
			<div class='lg-contain-margin' v-for="(item,index) in menus" :key="item.id">
				<div class='modular-title'>
					<h2>
						<span class="line-left"></span>
						{{item.name}}
						<span class="line-right"></span>
					</h2>
					<router-link :to="{path:'/course'}"><h2 class="more">查看更多 <span class="el-icon-arrow-right"></span></h2></router-link>
				</div>
				<div class="menus-list">
					<div class="item" v-for="(str,index) in item.children" :key="index" @click="handleMenusOpen(str)">
						<img :src="str.icon_url" class="item-avatar" alt="">
						<p class="name">{{str.name}}</p>
					</div>
				</div>
			</div>
		</div>
		<div class='lg-contain-margin new-teacher' v-if="teacher_list.length !==0">
			<div class='modular-title'>
				<h2>
					<span class="line-left"></span>
					推荐名师
					<span class="line-right"></span>
				</h2>
				<router-link :to="{path:'/teacher/list'}"><h2 class="more">查看更多 <span class="el-icon-arrow-right"></span></h2></router-link>
			</div>
			<teacher :formData="teacher_list"/>
		</div>
		<div class='lg-contain-margin new-video' style="background-color: #F4F4F4" v-if="new_video.length !==0">
			<div class='modular-title'>
				<h2>
					<span class="line-left"></span>
					新上好课
					<span class="line-right"></span>
				</h2>
				<router-link :to="{path:'/course'}"><h2 class="more">查看更多 <span class="el-icon-arrow-right"></span></h2></router-link>
			</div>
<!--			<div class="video-category">-->
<!--				<span @click="handleSelectVideo(item.id)" :style="{color:video_form.category_id === item.id ? '#ffde00':''}" class="lg-list-item" v-for="item in video_category" :key="item.id">{{item.name}}</span>-->
<!--			</div>-->
			<course :formData="new_video" />
		</div>
		<div class='lg-contain-margin new-video' style="background-color: #F4F4F4" v-if="rec_video.length !==0">
			<div class='modular-title'>
				<h2>
					<span class="line-left"></span>
					精选好课
					<span class="line-right"></span>
				</h2>
				<router-link :to="{path:'/course'}"><h2 class="more">查看更多 <span class="el-icon-arrow-right"></span></h2></router-link>
			</div>
			<!--			<div class="video-category">-->
			<!--				<span @click="handleSelectVideo(item.id)" :style="{color:video_form.category_id === item.id ? '#ffde00':''}" class="lg-list-item" v-for="item in video_category" :key="item.id">{{item.name}}</span>-->
			<!--			</div>-->
			<course :formData="rec_video" />
		</div>
	</div>
</template>

<script>
	import teacher from "../components/teacher/index";
  export default {
    components:{teacher},
    data () {
      return {
        // 轮播
        carouselList: [],
        // 菜单列表
        menus:[],
        // 名师
        teacher_list:[],
        // 最新视频
        new_video:[],
        // 精选好课
        rec_video:[],
        // 推荐设计师
        user_list:[],
        // 视频分类
        video_category:[],
        video_form:{
          category_id:0
        },
        user_info:JSON.parse(localStorage.getItem('user-info'))
      }
    },
    mounted(){
      this.handleGetData()
    },
    methods: {
      handleMenusOpen(data){
        if (parseFloat(data.open_type) === 0) {
          this.$router.push({name:'course_index',params:{id:data.category_id}})
        } else if (parseFloat(data.open_type) === 2) {
          this.$router.push({name:'found_index',query:{id:data.category_id,category:"material"}})
        } else if (parseFloat(data.open_type) === 1) {
          this.$router.push({name:'found_index',query:{id:data.category_id,category:'work'}})
        }
      },
      // 视频分类
      handleSelectVideo(data){
        this.video_form.category_id = data
      },
      // 数据
      handleGetData(){
        this.$requestApi.video.videoCategory().then(res => {
          this.video_category = res.data
          this.video_category.unshift({id:0,name:'全部'})
        })
        this.$requestApi.index.home_data({tag:'new_course'}).then(res => this.new_video = res.data)
        this.$requestApi.index.home_data({tag:'menus'}).then(res => this.menus = res.data)
        this.$requestApi.index.home_data({tag:'rec_course'}).then(res => this.rec_video = res.data)
        this.$requestApi.index.home_data({tag:'rec_teacher'}).then(res => this.teacher_list = res.data)
        this.$requestApi.index.slideList({type:'client'}).then( res => {this.carouselList = res.data})
      },
      // 幻灯片跳转
      handleCarouselJump(data) {
        if (data.page !== null) {
          const {href} = this.$router.resolve({
            name: 'single_page',
            query: {
              id:data.page,
              type:'advertising'
            }
          })
          window.open(href, '_blank')
        } else window.open(data.link)
      },
      // 详情
      handelOpenDetail(url,data){
        const {href} = this.$router.resolve({
          name: url,
          query: {
            id:data
          }
        })
        window.open(href, '_blank')
      }
    },
  }
</script>
<style lang="less">
	.index-banner{
		.el-carousel__container{
			height: 400px;
		}
		.el-carousel__indicator.is-active button,.el-carousel__indicators--outside .el-carousel__indicator:hover button{
			background-color: #ffde00;
		}
		.el-carousel__button{
			width:47px;
			height:5px;
		}
		.el-carousel__arrow:hover,.el-carousel__arrow{
			background-color: #ffffff;
		}
	}

</style>
<style scoped lang="less">
	.index-content{
		padding-bottom: 30px;
		background-color: #F4F4F4;
		.new-video{
			.video-category{
				span{
					margin-right: 20px;
					font-size: 15px;
					margin-bottom: 10px;
					display: inline-block;
					cursor: pointer;
				}
				span:hover{
					color: #ffde00;
				}
			}
		}
		/*名称*/
		.modular-title{
			margin: 20px 0 30px;
			position: relative;
			h2{
				font-size: 22px;
				position: relative;
				font-weight: 600;
				line-height: 1.1;
				color: #333333;
				text-align: center;
				display: flex;
				align-items: center;
				justify-content: center;
				.line-left{
					width: 150px;
					height: 2px;
					display: inline-block;
					background:linear-gradient(to left, #ffde00, #fdf1b4);
					margin-right: 20px;
				}
				.line-right{
					width: 150px;
					height: 2px;
					display: inline-block;
					background:linear-gradient(to right, #ffde00, #fdf1b4);
					margin-left: 20px;
				}
			}
			.more{
				font-size: 15px;
				color: #999999;
				font-weight: normal;
				position: absolute;
				right: 0;
				top: 7px;
				.el-icon-arrow-right:before{
					color: #999999;
					font-size: 15px;
				}
			}
		}
		/*轮播图*/
		.banner-img{
			width: 100%;
			height: 100%;
			cursor: pointer;
		}
		.space{
			margin-bottom: 20px;
		}
		/*菜单*/
		.menus-list{
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;
			cursor: pointer;
			.item{
				width: 250px;
				height: 108px;
				background: #FFFFFF;
				box-shadow: 0 5px 12px 3px rgba(62, 119, 250, 0.05);
				border-radius: 12px;
				display: flex;
				justify-content: center;
				align-items: center;
				margin-bottom: 20px;
				.item-avatar{
					width: 44px;
					height: 44px;
					border: 2px solid #FFFFFF;
					border-radius: 18px;
				}
				.name{
					color: #333333;
					font-size: 18px;
					margin-left: 10px;
					font-family: Source Han Sans CN;
					font-weight: 400;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue